module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$store.state.login.loginUsuario.token || _vm.rotasNaoAutenticadas()) ? _c('section', [_c('div', {
    class: (this.$store.state.login.loginUsuario.token ? 'wrapper' : 'wrapper menu-rota-nao-autenticada')
  }, [(this.$store.state.login.loginUsuario.token) ? _c('va-navibar') : _vm._e(), _vm._v(" "), _c('va-slider', {
    attrs: {
      "slideMenuItems": _vm.slideMenuItems
    }
  }), _vm._v(" "), _c('va-content-wrap')], 1), _vm._v(" "), _c('div', [_c('redirecionar-usuario-apos-login')], 1)]) : (this.$route.path == '/autenticar') ? _c('section', [_c('login-ssp')], 1) : _c('section', [_c('Login')], 1), _vm._v(" "), _c('section', [_c('Modals')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd26cd6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1021
// module chunks = 1